import { Typography, Card, useTheme } from "@mui/material";

import BecomeDealerForm from "./BecomeDealerForm";
import DownloadAppCard from "./DownloadAppCard";
import { getCardStyles } from "./BecomeDealerForm/styles";

interface IProps {
  cardIndex: number;
  title: string;
  description: string;
  goToNextStep?: () => void;
}

const BecomeDealerCard: React.FC<IProps> = ({
  title,
  description,
  cardIndex,
  goToNextStep,
}) => {
  const theme = useTheme();

  return (
    <Card variant="outlined" sx={getCardStyles(theme)}>
      <Typography variant="h4" component="h3" color="text.primary" mb={2}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        fontSize={{ sm: 16 }}
        lineHeight={0.9}
        mb={{ xs: [4, 2.25, 0][cardIndex], md: [4, 4, 0][cardIndex] }}
      >
        {description}
      </Typography>
      {cardIndex === 0 && (
        <BecomeDealerForm 
          goToNextStep={goToNextStep} 
        />
      )}
      {cardIndex === 1 && (
        <DownloadAppCard/>
      )}
    </Card>
  );
};

export default BecomeDealerCard;
